<!-- Interactivities Tab Content extracted into child component -->
<div *ngIf="scenario?.interactivities">
  <h5 style="display:inline-block; margin-right:12px">Interactivities</h5>
  <button class="btn btn-sm btn-primary" style="vertical-align:middle" (click)="addInteractivity()">Add Interactivity</button>
  <i class="bi bi-question-circle" style="font-size: 1.5em;margin-left:20px;color:gray;margin-top:-10px" (click)="showInteractivityInfo = !showInteractivityInfo"></i>
  <button class="btn btn-link btn-sm" style="text-decoration:none;margin-left:12px" (click)="showInteractivityClassList = !showInteractivityClassList">
    {{ showInteractivityClassList ? 'Hide' : 'Show' }} Allowed Classes
  </button>

  <div *ngIf="showInteractivityClassList" class="mt-2 mb-3 p-2 border rounded bg-light">
    <div class="small text-muted" style="margin-bottom:4px">Classes discovered from ScenarioClasses (dynamic)</div>
    <div class="accordion" id="interactivityClassAccordion">
      <div class="accordion-item" *ngFor="let cls of allowedInteractivityClasses; let i = index">
        <h2 class="accordion-header" [id]="'ica-head-' + i">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#ica-collapse-' + i" aria-expanded="false" [attr.aria-controls]="'ica-collapse-' + i" style="padding:4px 12px;font-size:.85rem">
            {{ cls }}
          </button>
        </h2>
        <div [id]="'ica-collapse-' + i" class="accordion-collapse collapse" [attr.aria-labelledby]="'ica-head-' + i" data-bs-parent="#interactivityClassAccordion">
          <div class="accordion-body" style="padding:6px 12px;font-size:.8rem">
            <a href="javascript:void(0)" (click)="pickInteractivityClass(cls); showInteractivityClassList = false">Select {{ cls }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="showInteractivityInfo" style="margin:20px;padding:20px;background-color:lightgray;border:solid 1px gray">
    <section>
      <p>
        This table lists interactivities that are programmatically implemented in the exercise code. The parameters for each interactivity
        are captured in a JSON object, and the structure of the JSON object varies depending on the specific interactivity.
      </p>
      <p>Some properties are common across most interactivities:</p>
      <ul>
        <li><strong>Class</strong>: Determines the code (Class) to be executed during exercise loading.</li>
        <li><strong>seqNo</strong>: Helps sort the list. The implementation Classes are called in this order.</li>
        <li><strong>lessonplanid</strong>: Links the interactivity to a lesson plan step using an ID for matching.</li>
      </ul>
    </section>
  </div>

  <table class="table table-bordered">
    <thead>
      <tr>
        <th style="cursor:pointer;white-space:nowrap" (click)="sortBy('class')">
          Class
          <i class="bi" [ngClass]="sortField==='class' ? (sortDir==='asc' ? 'bi-sort-alpha-down' : 'bi-sort-alpha-up') : 'bi-arrow-down-up'" style="font-size:.8rem;margin-left:4px;color:gray"></i>
        </th>
        <th>Enabled</th>
        <th style="cursor:pointer;white-space:nowrap" (click)="sortBy('seqNo')">
          SeqNo
          <i class="bi" [ngClass]="sortField==='seqNo' ? (sortDir==='asc' ? 'bi-sort-numeric-down' : 'bi-sort-numeric-up') : 'bi-arrow-down-up'" style="font-size:.8rem;margin-left:4px;color:gray"></i>
        </th>
        <th>Edit</th>
        <th style="cursor:pointer;white-space:nowrap" (click)="sortBy('name')">
          Name
          <i class="bi" [ngClass]="sortField==='name' ? (sortDir==='asc' ? 'bi-sort-alpha-down' : 'bi-sort-alpha-up') : 'bi-arrow-down-up'" style="font-size:.8rem;margin-left:4px;color:gray"></i>
        </th>
        <th>JSON Object</th>
        <th>Delete</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of sortedInteractivities">
        <td>{{row.item.class}}</td>
        <td><input type="checkbox" [(ngModel)]="row.item.enabled"></td>
        <td>{{row.item.seqNo}}</td>
        <td><i class="bi bi-pencil" style="color:green" (click)="editInteractivity(row.item, row.index)"></i></td>
        <td>{{row.item.name}}</td>
        <td>{{row.item | json}}</td>
        <td><i class="bi bi-trash" style="color:orange" (click)="deleteInteractivity(row.index)"></i></td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Base / Default editor (shared fields) - Bootstrap centered -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivity}" [ngStyle]="{ display: showInteractivity ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'Interactivity' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
    <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
      Class value must match an implemented class name listed in scenarioclasses. The name value must match a lesson plan entry (lessonplan.name) when linkage is required. Keep spelling & case exact; otherwise the runtime won’t instantiate or link the interactivity.
    </div>
    <div class="modal-body">
      <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
    <div class="row g-3">
      <div class="col-md-4">
        <div class="inline" style="display:block"><sa-input-text [(text)]="interactivity.class" [title]="'class'"></sa-input-text></div>
        <div class="inline" style="display:block"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
        <div class="inline" style="display:block"><sa-input-text [(text)]="interactivity.name" [title]="'name'"></sa-input-text></div>
        <div class="inline" style="display:block"><sa-input-number [(text)]="interactivity.seqNo" [title]="'seqNo'"></sa-input-number></div>
        <div class="inline" style="display:block"><sa-input-text [(text)]="interactivity.component" [title]="'component'"></sa-input-text></div>
        <div class="inline" style="display:block; margin-top:6px">
          <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Teacher Controlled</label>
          <input type="checkbox" [(ngModel)]="interactivity.isTeacherControlled" />
        </div>
      </div>
      <div class="col-md-4">
        <b>Lessonplan Steps</b>
        <div *ngFor="let l of scenario.lessonplan">{{l.id}} <span style="color:gray">({{l.name}})</span></div>
      </div>
      <div class="col-md-4">
        <div style="max-width:600px;margin-top:20px"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
        <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from JSON</button>
        </div>
      </div>
    </div>
    <div class="modal-footer" style="justify-content:space-between; width:100%">
      <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
      <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
    </div>
    </div>
  </div>
</div>

<!-- Modal Compass (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityCompass}" [ngStyle]="{ display: showInteractivityCompass ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'Compass' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline" style="display:block"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline" style="display:block"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline" style="display:block"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline" style="display:block"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (incl. Class)</div>
            <div class="text-muted small" style="margin-top:4px">No extra fields</div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Fire (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityFire}" [ngStyle]="{ display: showInteractivityFire ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'Fire' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (incl. Class)</div>
            <!-- Class now chosen in base column -->
            <div class="inline"><sa-input-number [(text)]="interactivity.posX" [title]="'posX'"></sa-input-number></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.posY" [title]="'posY'"></sa-input-number></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.posZ" [title]="'posZ'"></sa-input-number></div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Approach (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityApproach}" [ngStyle]="{ display: showInteractivityApproach ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'Approach' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Approach-specific properties</div>
            <div class="inline"><sa-input-number [(text)]="interactivity.maxNumberOfSteps" [title]="'Max Number of Steps'"></sa-input-number></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.penaltySteps" [title]="'Penalty Steps (seconds)'"></sa-input-number></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.minWaitForSensor" [title]="'Min Wait for Sensor (seconds)'"></sa-input-number></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.penaltyWaitForSensor" [title]="'Penalty Wait for Sensor (seconds)'"></sa-input-number></div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal GateOpenClose (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityGateOpenClose}" [ngStyle]="{ display: showInteractivityGateOpenClose ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'GateOpenClose' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (GateOpenClose)</div>
            <div class="mb-3">
              <label class="form-label small">Open Actions</label>
              <div *ngFor="let openAction of interactivity.open; let i = index; trackBy: trackByOpenIndex" class="input-group input-group-sm mb-2">
                <span class="input-group-text">{{ i + 1 }}</span>
                <input class="form-control" [(ngModel)]="interactivity.open[i]" [placeholder]="'Open action ' + (i + 1)" />
                <button class="btn btn-outline-danger" type="button" (click)="removeOpenAction(i)" *ngIf="interactivity.open.length > 1">
                  <i class="bi bi-x"></i>
                </button>
              </div>
              <button class="btn btn-outline-primary btn-sm" (click)="addOpenAction()" type="button">
                <i class="bi bi-plus"></i> Add Open Action
              </button>
            </div>
            <div class="mb-3">
              <label class="form-label small">Close Actions</label>
              <div *ngFor="let closeAction of interactivity.close; let i = index; trackBy: trackByCloseIndex" class="input-group input-group-sm mb-2">
                <span class="input-group-text">{{ i + 1 }}</span>
                <input class="form-control" [(ngModel)]="interactivity.close[i]" [placeholder]="'Close action ' + (i + 1)" />
                <button class="btn btn-outline-danger" type="button" (click)="removeCloseAction(i)" *ngIf="interactivity.close.length > 1">
                  <i class="bi bi-x"></i>
                </button>
              </div>
              <button class="btn btn-outline-primary btn-sm" (click)="addCloseAction()" type="button">
                <i class="bi bi-plus"></i> Add Close Action
              </button>
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Grass (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityGrass}" [ngStyle]="{ display: showInteractivityGrass ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'Grass' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match the corresponding lesson plan name (case sensitive) if linkage is expected.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (incl. Class)</div>
            <!-- Class now chosen in base column -->
            <div class="inline"><sa-input-number [(text)]="interactivity.xPos" [title]="'xPos'"></sa-input-number></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.zPos" [title]="'zPos'"></sa-input-number></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.radius" [title]="'radius'"></sa-input-number></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.nBlades" [title]="'nBlades'"></sa-input-number></div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>


<!-- Modal PPE (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityPPE}" [ngStyle]="{ display: showInteractivityPPE ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'PPE' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline" style="display:block"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline" style="display:block"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline" style="display:block"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline" style="display:block"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Teacher Controlled</label>
              <input type="checkbox" [(ngModel)]="interactivity.isTeacherControlled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">PPE Files (without .glb)</div>
            <div class="text-muted small" *ngIf="!interactivity.ppefiles || interactivity.ppefiles.length === 0">No PPE files yet</div>
            <div class="mb-2" *ngIf="interactivity.ppefiles && interactivity.ppefiles.length > 0">
              <div class="border rounded p-2 mb-2" *ngFor="let file of interactivity.ppefiles; let i = index; trackBy: trackByOpenIndex">
                <div class="d-flex justify-content-between align-items-center mb-1">
                  <span class="small text-muted">File {{ i + 1 }}</span>
                  <button class="btn btn-outline-danger btn-sm" (click)="interactivity.ppefiles.splice(i,1)"><i class="bi bi-x"></i></button>
                </div>
                <div class="mb-1">
                  <label class="form-label" style="font-size:.7rem;text-transform:uppercase;margin-bottom:1px">Filename</label>
                  <input class="form-control form-control-sm" [(ngModel)]="file.filename" placeholder="filename (without .glb)" />
                </div>
                <div class="mb-1">
                  <label class="form-label" style="font-size:.7rem;text-transform:uppercase;margin-bottom:1px">Title</label>
                  <input class="form-control form-control-sm" [(ngModel)]="file.title" placeholder="Title" />
                </div>
                <div>
                  <label class="form-label" style="font-size:.7rem;text-transform:uppercase;margin-bottom:1px">Description</label>
                  <input class="form-control form-control-sm" [(ngModel)]="file.description" placeholder="Description" />
                </div>
              </div>
            </div>
            <div class="input-group input-group-sm">
              <input #newPPEFile class="form-control" placeholder="New PPE file name" />
              <button class="btn btn-outline-primary" type="button" (click)="addPPEFile(newPPEFile.value); newPPEFile.value='';">Add</button>
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Roles (Bootstrap centered) - standalone (previously nested inside Tracker modal) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityRoles}" [ngStyle]="{ display: showInteractivityRoles ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'Roles' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Teacher Controlled</label>
              <input type="checkbox" [(ngModel)]="interactivity.isTeacherControlled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Roles</div>
            <div class="text-muted small" *ngIf="!interactivity.roleNames || interactivity.roleNames.length === 0">No roles yet</div>
            <ul class="list-group mb-2" *ngIf="interactivity.roleNames && interactivity.roleNames.length > 0">
              <li class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let r of interactivity.roleNames; let i = index">
                <input class="form-control form-control-sm" [(ngModel)]="interactivity.roleNames[i]" />
                <button class="btn btn-outline-danger btn-sm ms-2" (click)="interactivity.roleNames.splice(i,1)"><i class="bi bi-x"></i></button>
              </li>
            </ul>
            <div class="input-group input-group-sm">
              <input #newRole class="form-control" placeholder="New role name" />
              <button class="btn btn-outline-primary" type="button" (click)="(interactivity.roleNames = interactivity.roleNames || []).push(newRole.value); newRole.value='';">Add</button>
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal SensorSim (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivitySensorSim}" [ngStyle]="{ display: showInteractivitySensorSim ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'SensorSim' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline" style="display:block"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline" style="display:block"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline" style="display:block"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline" style="display:block"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Teacher Controlled</label>
              <input type="checkbox" [(ngModel)]="interactivity.isTeacherControlled" />
            </div>
          </div>
          <div class="col-md-8">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="fw-bold small text-uppercase">Component / Sensor Relationships</div>
              <button class="btn btn-outline-primary btn-sm" type="button" (click)="(interactivity.components = interactivity.components || []).push({componentName: '', sensor: '', levelAt1: 0});">
                <i class="bi bi-plus"></i> Add Relationship
              </button>
            </div>
            <div class="text-muted small" *ngIf="!interactivity.components || interactivity.components.length === 0">No sensor components yet</div>
            <div *ngIf="interactivity.components && interactivity.components.length > 0">
              <!-- Column Headers -->
              <div class="d-flex align-items-center mb-2 fw-bold small text-muted border-bottom pb-1">
                <div class="flex-fill me-2" style="max-width:200px">Component Name</div>
                <div class="flex-fill me-2" style="max-width:150px">Sensor Type</div>
                <div class="flex-fill me-2" style="max-width:100px">Level at 1m</div>
                <div style="width:40px">Action</div>
              </div>
              <!-- Component Rows -->
              <div class="border rounded p-2" style="max-height:250px;overflow:auto">
                <div class="d-flex align-items-center mb-2 border-bottom pb-2" *ngFor="let comp of interactivity.components; let i = index">
                  <div class="flex-fill me-2" style="max-width:200px">
                    <div class="input-group input-group-sm">
                      <input class="form-control" [(ngModel)]="interactivity.components[i].componentName" placeholder="Component name" />
                      <button class="btn btn-outline-secondary" type="button" (click)="showComponentNameList[i] = !showComponentNameList[i]">{{ showComponentNameList[i] ? 'Hide' : 'Show' }}</button>
                    </div>
                    <div *ngIf="showComponentNameList[i]" class="mt-1 border rounded p-2 bg-light" style="max-height:120px;overflow:auto">
                      <ul class="list-unstyled mb-0">
                        <li *ngFor="let compName of availableComponentNames"><a href="javascript:void(0)" (click)="pickComponentId(compName, i)">{{ compName }}</a></li>
                      </ul>
                      <div *ngIf="availableComponentNames.length === 0" class="text-muted small">No components found</div>
                    </div>
                  </div>
                  <div class="flex-fill me-2" style="max-width:150px">
                    <div class="input-group input-group-sm">
                      <input class="form-control" [(ngModel)]="interactivity.components[i].sensor" placeholder="Sensor" />
                      <button class="btn btn-outline-secondary" type="button" (click)="showSensorTypeList[i] = !showSensorTypeList[i]">{{ showSensorTypeList[i] ? 'Hide' : 'Show' }}</button>
                    </div>
                    <div *ngIf="showSensorTypeList[i]" class="mt-1 border rounded p-2 bg-light" style="max-height:120px;overflow:auto">
                      <ul class="list-unstyled mb-0">
                        <li *ngFor="let sensorType of availableSensorTypes"><a href="javascript:void(0)" (click)="pickSensorType(sensorType, i)">{{ sensorType }}</a></li>
                      </ul>
                    </div>
                  </div>
                  <div class="flex-fill me-2" style="max-width:100px">
                    <input class="form-control form-control-sm" type="number" [(ngModel)]="interactivity.components[i].levelAt1" placeholder="Level" />
                  </div>
                  <div>
                    <button class="btn btn-outline-danger btn-sm" (click)="interactivity.components.splice(i,1)" title="Remove component"><i class="bi bi-trash"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row g-3 mt-2">
          <div class="col-12">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="8"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Smoke (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivitySmoke}" [ngStyle]="{ display: showInteractivitySmoke ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'Smoke' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (incl. Class)</div>
            <div class="inline"><sa-input-text [(text)]="interactivity.type" [title]="'Type'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.posX" [title]="'posX'"></sa-input-number></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.posY" [title]="'posY'"></sa-input-number></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.posZ" [title]="'posZ'"></sa-input-number></div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Tracker (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityTracker}" [ngStyle]="{ display: showInteractivityTracker ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'Tracker' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (incl. Class)</div>
            <!-- Class now chosen in base column -->
            <label class="form-label" style="margin-top:8px">modalHTMLFileName</label>
            <div class="input-group" style="max-width: 100%">
              <input class="form-control" [(ngModel)]="interactivity.modalHTMLFileName" placeholder="modalHTMLFileName (e.g. scenarioDescription.html)" />
              <button class="btn btn-outline-secondary btn-sm" type="button" (click)="showModalHtmlFileList = !showModalHtmlFileList">{{ showModalHtmlFileList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showModalHtmlFileList" class="mt-2 border rounded p-2 bg-light">
              <small class="text-muted">Pick existing file:</small>
              <ul class="list-unstyled mb-0">
                <li *ngFor="let f of allowedModalHtmlFiles"><a href="javascript:void(0)" (click)="pickModalHtmlFile(f)">{{ f }}</a></li>
              </ul>
            </div>
            <label class="form-label" style="margin-top:8px">modalId</label>
            <div class="input-group" style="max-width: 100%">
              <input class="form-control" [(ngModel)]="interactivity.modalId" placeholder="modalId (e.g. navigationModalId)" />
              <button class="btn btn-outline-secondary btn-sm" type="button" (click)="showModalIdList = !showModalIdList">{{ showModalIdList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showModalIdList" class="mt-2 border rounded p-2 bg-light">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let m of allowedModalIds"><a href="javascript:void(0)" (click)="pickModalId(m)">{{ m }}</a></li>
              </ul>
            </div>
            <label class="form-label" style="margin-top:8px">syncScope</label>
            <div class="inline" style="display:flex; align-items:center; gap:8px; flex-wrap: wrap;">
              <select class="form-select form-select-sm" [(ngModel)]="interactivity.syncScope" style="max-width:220px">
                <option [ngValue]="'global'">global</option>
                <option [ngValue]="'local'">local</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <div class="d-flex" style="gap:8px; flex-wrap: wrap; margin-top:8px">
              <button class="btn btn-secondary" (click)="formatInteractivityText()">Format JSON</button>
              <button class="btn btn-info" (click)="saveInteractivityFromJsonString()">Update from string</button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal WindDirection (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityWindDirection}" [ngStyle]="{ display: showInteractivityWindDirection ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'WindDirection' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline" style="display:block"><sa-select [(Id)]="interactivity.name" [title]="'Name'" [options]="lessonplanSteps" [IdField]="'name'" [NameField]="'name'"></sa-select></div>
            <div class="inline" style="display:block"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline" style="display:block"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline" style="display:block"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (incl. Class)</div>
            <div class="text-muted small" style="margin-top:4px">No extra fields</div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal WindHose (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityWindHose}" [ngStyle]="{ display: showInteractivityWindHose ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'WindHose' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline" style="display:block"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline" style="display:block"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline" style="display:block"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline" style="display:block"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (incl. Class)</div>
            <div class="text-muted small" style="margin-top:4px">No extra fields</div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal ExploreArec (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityExploreArec}" [ngStyle]="{ display: showInteractivityExploreArec ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'ExploreArec' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (incl. Class)</div>
            <div class="text-muted small" style="margin-top:4px">No extra fields</div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal ExploreMap (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityExploreMap}" [ngStyle]="{ display: showInteractivityExploreMap ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'ExploreMap' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (incl. Class)</div>
            <div class="text-muted small" style="margin-top:4px">No extra fields</div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Map (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityMap}" [ngStyle]="{ display: showInteractivityMap ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'Map' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties</div>
            <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">View Mode</label>
            <select class="form-select form-select-sm" [(ngModel)]="interactivity.viewMode">
              <option value="full">full</option>
              <option value="insert">insert</option>
              <option value="modal">modal</option>
            </select>
            <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-top:8px; margin-bottom:2px">Direction</label>
            <select class="form-select form-select-sm" [(ngModel)]="interactivity.direction">
              <option value="N">N</option>
              <option value="E">E</option>
              <option value="S">S</option>
              <option value="W">W</option>
            </select>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal ScenarioDescription (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityScenarioDescription}" [ngStyle]="{ display: showInteractivityScenarioDescription ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'ScenarioDescription' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <br><span style="color:red;">Make sure the domid exist in lessonplan steps.</span>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Teacher Controlled</label>
              <input type="checkbox" [(ngModel)]="interactivity.isTeacherControlled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (ScenarioDescription)</div>
            <div class="inline"><sa-input-text [(text)]="interactivity.htmlFileName" [title]="'HTML File Name'"></sa-input-text></div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>
<!-- Modal SickChar (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivitySickChar}" [ngStyle]="{ display: showInteractivitySickChar ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'SickChar' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <br><span style="color:red;">Make sure the domid exist in lessonplan steps.</span>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Teacher Controlled</label>
              <input type="checkbox" [(ngModel)]="interactivity.isTeacherControlled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (SickChar)</div>
            <div class="inline"><sa-input-text [(text)]="interactivity.scenario" [title]="'Scenario'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.animmation" [title]="'Animation'"></sa-input-text></div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>
<!-- Modal ModalDisplay (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityModalDisplay}" [ngStyle]="{ display: showInteractivityModalDisplay ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'ModalDisplay' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <br><span style="color:red;">Make sure the domid exists in lessonplan steps.</span>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Teacher Controlled</label>
              <input type="checkbox" [(ngModel)]="interactivity.isTeacherControlled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (ModalDisplay)</div>
            <div class="inline"><sa-input-text [(text)]="interactivity.htmlFileName" [title]="'HTML File Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.modalid" [title]="'Modal ID'"></sa-input-text></div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>
<!-- Modal LabelDisplay (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityLabelDisplay}" [ngStyle]="{ display: showInteractivityLabelDisplay ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'LabelDisplay' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <br><span style="color:red;">Make sure the domid exist in lessonplan steps.</span>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (LabelDisplay)</div>
            <div class="inline"><sa-input-text [(text)]="interactivity.htmlFileName" [title]="'HTML File Name'"></sa-input-text></div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Tankertruck (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityTankertruck}" [ngStyle]="{ display: showInteractivityTankertruck ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'Tankertruck' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Teacher Controlled</label>
              <input type="checkbox" [(ngModel)]="interactivity.isTeacherControlled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (Tankertruck)</div>
            <div class="inline"><sa-input-text [(text)]="interactivity.doorMesh" [title]="'Door Mesh'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.documentation" [title]="'Documentation'"></sa-input-text></div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Manhole (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityManhole}" [ngStyle]="{ display: showInteractivityManhole ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'Manhole' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (Manhole)</div>
            <div class="inline"><sa-input-text [(text)]="interactivity.animation" [title]="'Animation'"></sa-input-text></div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal PhaseInOut (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityPhaseInOut}" [ngStyle]="{ display: showInteractivityPhaseInOut ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'PhaseInOut' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (PhaseInOut)</div>
            <div class="inline"><sa-input-number [(text)]="interactivity.duration" [title]="'Duration (seconds)'"></sa-input-number></div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Hyperlink (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityHyperlink}" [ngStyle]="{ display: showInteractivityHyperlink ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'Hyperlink' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <br><span style="color:red;">Make sure the domid exist in lessonplan steps.</span>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (Hyperlink)</div>
            <div class="inline"><sa-input-text [(text)]="interactivity.hyperlink" [title]="'Hyperlink'"></sa-input-text></div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal PlayAnimation (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityPlayAnimation}" [ngStyle]="{ display: showInteractivityPlayAnimation ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'PlayAnimation' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (PlayAnimation)</div>
            <div class="inline"><sa-input-text [(text)]="interactivity.animation" [title]="'Animation'"></sa-input-text></div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal ShowHide (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityShowHide}" [ngStyle]="{ display: showInteractivityShowHide ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'ShowHide' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (ShowHide)</div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">isShow (true = show, false = hide)</label>
              <input type="checkbox" [(ngModel)]="interactivity.isShow" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal PlayAudio (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityPlayAudio}" [ngStyle]="{ display: showInteractivityPlayAudio ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'PlayAudio' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (PlayAudio)</div>
            <div class="inline"><sa-input-text [(text)]="interactivity.audiofile" [title]="'Audio File'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.title" [title]="'Title'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.description" [title]="'Description'"></sa-input-text></div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Rotate (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityRotate}" [ngStyle]="{ display: showInteractivityRotate ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'Rotate' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (Rotate)</div>
            <div class="inline" style="display:block">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Rotation Axis</label>
              <select class="form-select form-select-sm" [(ngModel)]="interactivity.rotAxis">
                <option value="x">x</option>
                <option value="y">y</option>
                <option value="z">z</option>
              </select>
            </div>
            <div class="inline"><sa-input-number [(text)]="interactivity.rotAngle" [title]="'Rotation Angle (degrees)'"></sa-input-number></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.duration" [title]="'Duration (seconds)'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.tooltip" [title]="'Tooltip'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.toastOn" [title]="'Toast On'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.toastOff" [title]="'Toast Off'"></sa-input-text></div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Boiler (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityBoiler}" [ngStyle]="{ display: showInteractivityBoiler ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'Boiler' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (Boiler)</div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid_vent" [title]="'domid_vent'"></sa-input-text></div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal WeatherStation (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivityWeatherStation}" [ngStyle]="{ display: showInteractivityWeatherStation ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'WeatherStation' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (WeatherStation)</div>
            <div class="inline"><sa-input-number [(text)]="interactivity.temperature" [title]="'Temperature (°C)'"></sa-input-number></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.humidity" [title]="'Humidity (%)'"></sa-input-number></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.pressure" [title]="'Pressure (hPa)'"></sa-input-number></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.windspeed" [title]="'Wind Speed (km/h)'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.winddirection" [title]="'Wind Direction (N, NE, E, SE, S, SW, W, NW)'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.rainfall" [title]="'Rainfall (mm)'"></sa-input-number></div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Sewer (Bootstrap centered) -->
<div class="modal" tabindex="-1" [ngClass]="{show: showInteractivitySewer}" [ngStyle]="{ display: showInteractivitySewer ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content modal-elevated">
      <div class="modal-header cpmodal-header" style="align-items:center; border-top-left-radius:6px; border-top-right-radius:6px;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Interactivity - {{ interactivity?.class || 'Sewer' }}</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showClassNameInfo = !showClassNameInfo" title="Class / Name requirements">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllInteractivityModals()"></button>
      </div>
      <div *ngIf="showClassNameInfo" class="alert alert-info small" style="margin:8px 12px 0 12px;">
        Class must exist in scenarioclasses; Name should match a lesson plan step when linkage is required.
      </div>
      <div class="modal-body">
        <div *ngIf="showJsonError" class="alert alert-danger" role="alert">Failed to parse interactivity text</div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Base properties</div>
            <label class="form-label" style="margin-top:0">Class</label>
            <div class="input-group input-group-sm" style="max-width:100%">
              <input class="form-control" [(ngModel)]="interactivity.class" placeholder="Class" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">{{ showInteractivityClassList ? 'Hide' : 'Show' }}</button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light" style="max-height:160px;overflow:auto">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses"><a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a></li>
              </ul>
            </div>
            <div class="inline"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domid" [title]="'domid'"></sa-input-text></div>
            <div class="inline"><sa-input-number [(text)]="interactivity.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.component" [title]="'Component'"></sa-input-text></div>
            <div class="inline" style="display:block; margin-top:6px">
              <label class="form-label" style="display:block; font-size:.75rem; text-transform:uppercase; margin-bottom:2px">Enabled</label>
              <input type="checkbox" [(ngModel)]="interactivity.enabled" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Extended properties (Sewer)</div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domidFlush" [title]="'domidFlush'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domidExplosion" [title]="'domidExplosion'"></sa-input-text></div>
            <div class="inline"><sa-input-text [(text)]="interactivity.domidVentilate" [title]="'domidVentilate'"></sa-input-text></div>
          </div>
          <div class="col-md-4">
            <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
            <div style="margin-top:0"><sa-input-textarea [(text)]="interactivitytext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
            <button class="btn btn-info btn-sm mt-2" (click)="saveInteractivityFromJsonString()">Update from string</button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content:space-between; width:100%">
        <button class="btn btn-primary" (click)="saveInteractivity()">Update Interactivity</button>
        <button class="btn btn-secondary" (click)="closeAllInteractivityModals()">Cancel</button>
      </div>
    </div>
  </div>
</div>